import { gql } from "@apollo/client";

export const GET_ALLOCATION = gql`
  query allocationById($id: String!) {
    allocationById(id: $id) {
      id
      allocationType {
        key
        name
      }
      allocationCode
      level
      parentAllocationId
      parentAllocationName
    }
  }
`;

export const GET_ALLOCATIONS_INFINITE_SCROLL = gql`
  query allocationsInfiniteScroll(
    $first: Int
    $after: String
    $searchTerm: String
    $allocationType: AllocationTypeInput
    $showAll: Boolean
  ) {
    allocationsInfiniteScroll(
      first: $first
      after: $after
      searchTerm: $searchTerm
      allocationType: $allocationType
      showAll: $showAll
    ) {
      edges {
        cursor
        node {
          id
          allocationType {
            key
            name
          }
          allocationCode
          level
          editable
          visible
          parentAllocationId
          parentAllocationName
          cleanedSk
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_MY_ALLOCATIONS = gql`
  query myAllocations(
    $allocationType: AllocationTypeInput
    $scope: MyAllocationsScope
  ) {
    myAllocations(allocationType: $allocationType, scope: $scope) {
      id
      allocationType {
        key
        name
      }
      allocationCode
      level
      editable
      visible
      parentAllocationId
      parentAllocationName
      cleanedSk
    }
  }
`;

export const GET_ALLOCATION_TYPES = gql`
  query allocationTypes(
    $showAll: Boolean
    $isEditable: Boolean
    $withCounts: Boolean = false
  ) {
    allocationTypes(showAll: $showAll, isEditable: $isEditable) {
      key
      name
      integrationSourceSystem
      integrationEntity
      visible
      editable
      isLinkedCustomField
      allocationCount @include(if: $withCounts)
    }
  }
`;

export const ADD_ALLOCATION = gql`
  mutation addAllocation($input: AllocationInput!) {
    addAllocation(input: $input) {
      id
    }
  }
`;

export const UPDATE_ALLOCATION = gql`
  mutation updateAllocation($id: String!, $input: AllocationInput!) {
    updateAllocation(id: $id, input: $input) {
      id
    }
  }
`;

export const SET_ALLOCATION_VISIBILITY = gql`
  mutation setAllocationVisibility(
    $allocationTypeKey: String!
    $ids: [String!]!
    $visible: Boolean!
  ) {
    setAllocationVisibility(
      allocationTypeKey: $allocationTypeKey
      ids: $ids
      visible: $visible
    )
  }
`;

export const DELETE_ALLOCATION = gql`
  mutation deleteAllocation($id: String!, $clearAllocationsFromCards: Boolean) {
    deleteAllocation(
      id: $id
      clearAllocationsFromCards: $clearAllocationsFromCards
    ) {
      id
      message
    }
  }
`;
